/*
 * @Description  :
 * @Company      : Macrocura
 * @Author       : Zehui
 * @Date         : 2021-03-15 18:27:09
 */

import { ISales } from 'src/entity/DoctorEntity';
import * as React from 'react';
import { Select } from 'antd';
import I18N from 'src/services/I18NService';
import DoctorService from 'src/services/DoctorService';

interface ISalesSearchBoxState {
  // 销售数组
  sales: ISales[];
  timeout: number | undefined;
}

interface ISalesSearchBoxProps {
  onChange?: (value: string) => void;
  value?: string;
  parentCom?: string;
}

class SalesSearchBox extends React.Component<ISalesSearchBoxProps, ISalesSearchBoxState> {
  constructor(props: ISalesSearchBoxProps) {
    super(props);
    this.state = {
      // 销售数组
      sales: [],
      timeout: undefined,
    };
  }

  async componentDidMount() {
    this.getSales();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * @description 获取销售员数据
   *
   */
  async getSales() {
    try {
      const params = {
        fullname: '',
        offset: 0,
        limit: 100,
      };
      const res = await DoctorService.getSales(params);
      if (!!res) {
        const sales = res.results;
        this.setState({ sales });
      }
    } catch (error) {
      console.error(error);
    }
  }

  handleChange = (value: string) => {
    const { onChange } = this.props;
    if (onChange) {
        onChange(value);
      }
  }

  handleSalesSearch = (value: string) => {
    if (value) {
      if (this.state.timeout) {
        clearTimeout(this.state.timeout);
        this.setState({ timeout: undefined });
      }
      const timeout: number = window.setTimeout(async () => {
        const params = {
          fullname: value.trim(),
          offset: 0,
          limit: 100,
        };
        try {
          const res = await DoctorService.getSales(params);
          if (!!res) {
            const sales = res.results;
            this.setState({ sales });
          }
        } catch (error) {
          console.error(error);
        }
      }, 300);
      this.setState({ timeout });
    } else {
      this.setState({ sales: [] });
    }
  };

  render() {
    const { onChange, value, parentCom } = this.props;
    return (
      <Select
        showSearch={true}
        dropdownMatchSelectWidth={false}
        allowClear={true}
        placeholder={I18N.get('common_choose')}
        // optionFilterProp='children'
        onSearch={this.handleSalesSearch}
        onChange={this.handleChange}
        value={value}
        onSelect={onChange}
        filterOption={false}
        style={{ width: '100%' }}
      >
        <Select.Option value='-1'>{parentCom === 'assignSales' ?  I18N.get('doc_clear_sale') : I18N.get('doc_none_sale')}</Select.Option>
        {(this.state.sales || []).map((sale) => (
          <Select.Option key={sale.uuid} value={sale.uuid}>
            {`${sale.department_path}-${sale.fullname}`}
          </Select.Option>
        ))}
      </Select>
    );
  }
}
export default SalesSearchBox;



// WEBPACK FOOTER //
// ./src/components/common/SalesSearchBox.tsx